import { apiRequest } from "../api";

export const getSettings = () => apiRequest("/settings", "GET");
export const updateSettings = (payload: unknown) =>
  apiRequest("/settings", "PUT", payload);
